import { Alert, Box, CircularProgress, Grid, useTheme } from "@mui/material";

import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound';

import { KpiCard } from "../../programmeDashboard/components/KpiCard";
import { useCommercialDashboard } from "../hooks/useCommercialDashboard";
import { formatCurrency } from "../../../shared/utils";

export const DashboardStates = () => {

    const theme = useTheme();
    const { data: commercialsData, isLoading: isCommercialsDataLoading, isError: isCommercialsDataError, error: commercialsDataError } = useCommercialDashboard();

    const data = [
        {
            label: 'Programme Budget',
            value: formatCurrency(commercialsData.programme_budget),
            icon: <CurrencyPoundIcon fontSize="small" />,
        },
        {
            label: 'Forecast EAC',
            value: formatCurrency(commercialsData.programme_eac),
            subValue: '+2.1%',
            icon: <TrendingUpIcon fontSize="small" />,
        },
        {
            label: 'Total Commitments',
            value: formatCurrency(commercialsData.programme_commitments),
            percentageOfBudget: '97.0%',
            subValue: '97.0% of budget',
            icon: <CurrencyPoundIcon fontSize="small" />,
        },
        {
            label: 'Forecast Variance',
            value: formatCurrency(commercialsData.forecast_variance_value),
            subValue: '+2.1%',
            icon: <InfoOutlineIcon fontSize="small" />,
        },
        {
            label: 'Uncommitted Headroom',
            value: formatCurrency(commercialsData.uncommitted_headroom),
            percentageAvailable: '3.0%',
            subValue: '3.0% available',
            icon: <CurrencyPoundIcon fontSize="small" />,
        },
        {
            label: 'Actual Spend',
            value: formatCurrency(commercialsData.programme_actuals),
            percentageOfBudget: '64.2%',
            subValue: '64.2% of budget',
            icon: <TrendingUpIcon fontSize="small" />,
        },
        {
            label: 'Approved Variations',
            value: formatCurrency(commercialsData.approved_variations),
            icon: <CurrencyPoundIcon fontSize="small" />,
        },
        {
            label: 'Pending Variations',
            value: formatCurrency(commercialsData.pending_variations),
            icon: <InfoOutlineIcon fontSize="small" />,
        },
    ];

    if (isCommercialsDataLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                my={5}
            >
                <CircularProgress />
            </Box>
        )
    };

    if (isCommercialsDataError) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Alert
                    severity="warning"
                    sx={{
                        width: "auto",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    {commercialsDataError?.message || "Something went wrong!"}
                </Alert>
            </Box>
        );
    };

    return (
        <Grid container spacing={2} sx={{ mb: 3 }} px={2}>
            {data.map((item) => (
                <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.label}>
                    <KpiCard
                        label={item.label}
                        value={item.value}
                        icon={item.icon}
                        iconColor={theme.palette.info.main}
                        subValue={item.subValue}
                    />
                </Grid>
            ))}
        </Grid>
    )

}